import React from 'react';

const RecommendationCard = ({ 
  platform, 
  logo, 
  title, 
  description, 
  tag, 
  percentage, 
  isPositive 
}) => {
  return (
    <div className="recommendation-card">
      <div className="card-header">
        <div className="platform-info">
          <img src={logo} alt={platform} className="platform-logo" />
          <span>{platform}</span>
        </div>
        <div className="metrics">
          {tag && <span className="tag">{tag}</span>}
          <span className={`percentage ${isPositive ? 'positive' : 'negative'}`}>
            {percentage}
          </span>
        </div>
      </div>

      <h4 className="card-title">{title}</h4>
      <p className="card-description">{description}</p>

      <div className="card-actions">
        <button className="action-btn view">View recommendation</button>
        <button className="action-btn apply">Apply</button>
      </div>
    </div>
  );
};

export default RecommendationCard;